import moment from 'moment'
export class GetDateRange {
  public execute(numberOfDays: number): { startDate: Date; endDate: Date } {
    const endDate = moment().toDate()
    const startDate = moment().subtract(numberOfDays, 'days').toDate()
    return { startDate, endDate }
  }
}
